import api from "./Api";

class RegraComissaoTecnicoService {
  GetRegraComissaoTecnico(payload) {
    return api.get("/v1/regraComissaoTecnico/" + payload).then((response) => {
      return response.data;
    });
  }

  PostRegraComissaoTecnico(payload) {
    return api.post("/v1/regraComissaoTecnico/", payload).then((response) => {
      return response.data;
    });
  }

  PutRegraComissaoTecnico(payload) {
    return api.put("/v1/regraComissaoTecnico/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRegraComissaoTecnico(payload) {
    return api
      .delete("/v1/regraComissaoTecnico/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetRegraComissaoTecnicoOData(payload) {
    return api.get("/OData/RegraComissaoTecnico" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new RegraComissaoTecnicoService();
